import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import InboxTransitionBase from './InboxTransitionBase';
import { getFirstName } from '../../util/user';

const InboxTransitionSpecialCustomerPayment = ({ transition, user, ownRole, buttons }) => {
  const isOwnTransition = transition.by === ownRole;
  const displayName = getFirstName(get(user, 'attributes.profile.displayName', ''));

  return (
    <InboxTransitionBase
      date={transition.createdAt}
      direction="left"
      buttons={buttons}
      header={
        isOwnTransition ? (
          <FormattedMessage id="BookingStatus.ownTransitionSpecialOfferPaid" />
        ) : (
          <FormattedMessage
            id="BookingStatus.transitionSpecialOfferPaid"
            values={{ displayName }}
          />
        )
      }
    />
  );
};

export default InboxTransitionSpecialCustomerPayment;
